import axios from '../../helpers/axios-setup';
import { Certification } from '../../shared-components/condition-builder/types';

export const certificationAutoComplete = (queryString: string) =>
  axios.get<Certification[]>(`certifications/certifications?search=${queryString}&size=15&sort=name,desc`);
